import { Injectable, Injector } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { BitfAuthGuard } from '@bitf/core/services/guards/bitf-auth.guard';

import { EBitfUiMessageType, EResources } from '@web/enums';
import { ToastMessagesService } from '@services';
import { IBitfToastData } from '@interfaces';
import { BITF_CONFIGS } from '@common/configs/common-bitf.configs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends BitfAuthGuard {
  constructor(
    protected injector: Injector,
    private toastMessageService: ToastMessagesService,
    private translateService: TranslateService
  ) {
    super(injector);
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const bitfCanActivate = super.canActivate(next, state);
    if (typeof bitfCanActivate !== 'boolean') {
      // NOTE: Is an obserable
      return (bitfCanActivate as Observable<boolean>).pipe(
        switchMap(() => {
          return of(this.checkUserRoutePermission(next, state));
        })
      );
    }
    // NOTE: Is a boolean
    if (bitfCanActivate) {
      return this.checkUserRoutePermission(next, state);
    }
    return bitfCanActivate;
  }

  checkUserRoutePermission(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.storeService.store.user.isAuthorized) {
      this.router.navigate(['/unauthorized']);
      return false;
    }
    if (
      next.data.resources &&
      !next.data.resources.some(
        resource => !!this.storeService.store.user.resources.find(each => EResources[each] === resource)
      )
    ) {
      this.router.navigate(['/', BITF_CONFIGS.urls.homePageUrl]);
      return false;
    }

    return true;
  }
}
